<template>
    <div
        v-click-outside="hide"
        class="relative select-none md:pr-sm"
    >
        <div class="flex items-center cursor-pointer" @click.prevent="toggleVisibility">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="avatar" />
            <font-awesome-icon icon="caret-down" class="text-inherit ml-sm hidden md:flex" />
        </div>

        <div
            v-show="shouldShow"
            class="submenu"
        >
            <ul>
                <slot />
            </ul>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {
        directives: {
            ClickOutside,
        },
        props: {
            avatar: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                shouldShow: false,
            };
        },
        methods: {
            toggleVisibility() {
                this.shouldShow = ! this.shouldShow;
            },
            hide() {
                this.shouldShow = false;
            },
        },
    };
</script>